import { FunctionComponent as FC } from 'react';
import { withStyles, Icon } from 'vopay';
import styles from './Logos.module.scss';

const classes = withStyles(styles);

const Logos: FC = () => (
  <div className={classes('logosContainer')}>
    <Icon icon="cardVisa" color="none" />
    <Icon icon="cardMaster" color="none" />
    <Icon icon="interacColor" color="none" />
    <Icon icon="aicpaSoc" color="none" />
    <Icon icon="pci2" color="none" />
  </div>
);

export default Logos;
